<template>
    <div class="close-header-title no-con">
        <section class="privacy-section">
            <div class="container">
                <div class="main-heading">
                    <h1>About Us</h1>
                    <p>At Vanovy, we believe that access to dignified housing—whether temporary or
                        long-term—should not be a privilege. Our platform was founded with a clear mission: to redefine
                        temporary housing by making it more equitable, affordable, and humane.</p>
                    <p>We connect socially responsible property owners directly with individuals seeking reasonably
                        priced accommodations. By removing unnecessary intermediaries and simplifying the rental
                        process, we foster a more transparent, supportive experience for everyone involved.</p>
                </div>

                <div class="content-section center">
                    <h2>Our key differentiators include:</h2>
                    <ul class="bulleted-list">
                        <li><strong>Competitive pricing</strong> made possible through direct agreements with property
                            owners</li>
                        <li><strong>A zero-commission model</strong> for tenants—resources go toward rent, not fees</li>
                        <li><strong>End-to-end management and personalized support</strong> tailored to real relocation
                            challenges</li>
                        <li><strong>An intuitive platform</strong> designed for accessibility, clarity, and ease of use
                        </li>
                    </ul>

                    <h2>Who We Serve</h2>
                    <p>Our diverse community includes students, displaced families, professionals in transition, digital
                        nomads, and others navigating periods of change. Whether you're relocating for work, education,
                        or unexpected life events, Vanovy offers a stable, inclusive, and humane housing
                        solution.</p>

                    <h2>Our Mission</h2>
                    <p>More than just a booking service, Vanovy is a values-driven initiative leveraging
                        technology to promote housing stability, inclusion, and dignity for all.</p>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import API from '@/api';
import axios from 'axios';
import Vue from 'vue';

import { Loader } from '@googlemaps/js-api-loader';
export default {
    name: 'about_us',
    components: {
    },
    data() {
        return {

        }
    },
    mounted() {

    },
    methods: {
    },
    computed: {
    },
    created() {
    },
}
</script>
<style>
h2 {
    font-size: 32px;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 5px !important;
}

.bulleted-list {
    list-style-type: disc;
    padding-left: 20px;
}
</style>